export default {
  "name": "dev",
  "api": "https://api.dev.proapp.fi",
  "chat_api": "https://chat.dev.proapp.fi"
}
